import React from 'react'

import Base from '../_Base'

const Comments = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M21 3a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1h-6l-2.293 2.293a.997.997 0 0 1-1.414 0L9 20H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-1 2H4v13h5.829l.585.586L12 20.172l1.586-1.586.586-.586H20V5zm-4 8a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2zm0-5a1 1 0 1 1 0 2H8a1 1 0 0 1 0-2z"
      fillRule="evenodd"
    />
  </Base>
)

export default Comments
